class BindingError extends Error {
}
const throwBindingError = (message) => {
  throw new BindingError(message);
};
export {
  BindingError,
  throwBindingError
};
//# sourceMappingURL=BindingError.js.map
